import { Injectable } from '@angular/core';
import {
  ActionPerformed,
  PushNotificationSchema,
  PushNotifications,
  Token,
} from '@capacitor/push-notifications';
import { Device } from '@capacitor/device';
import { AlertController } from '@ionic/angular/lazy';
import { Browser } from '@capacitor/browser';
import { Router } from '@angular/router';
import { toHttpsUrl } from '../shared/url-safety';

@Injectable({
  providedIn: 'root'
})
export class FcmService {
  tokenPushUtente: any;

  constructor(
    private alertController: AlertController,
    private routingService: Router) {

  }

  initPush() {
    Device.getInfo().then(res => {
      if (res.platform !== 'web') {
        this.registerPush();
      }
    });
  }

  private registerPush() {
    PushNotifications.requestPermissions().then((permission) => {
      if (permission.receive) {
        // Register with Apple / Google to receive push via APNS/FCM
        PushNotifications.register();
      } else {
        // No permission for push granted
      }
    });

    PushNotifications.addListener(
      'registration',
      (token: Token) => {
        //console.log('My token: ' + JSON.stringify(token));
        this.tokenPushUtente = JSON.stringify(token.value);
      }
    );

    PushNotifications.addListener('registrationError', (error: any) => {
      //console.log('Error: ' + JSON.stringify(error));
    });

    PushNotifications.addListener(
      'pushNotificationReceived',
      async (notification: PushNotificationSchema) => {
        //console.log('Push received: ' + JSON.stringify(notification));
        const data = notification;
       // console.log(data.data);
        const alert = await this.alertController.create({
          header: JSON.stringify(notification.title).substring(1, JSON.stringify(notification.title).length - 1),
          message: JSON.stringify(notification.body).substring(1, JSON.stringify(notification.body).length - 1),
          buttons: [
            {
              text: 'OK',
              handler: async () => {
                if (data.data.url != '' && data.data.url != undefined) {
                  await this.apriUrlEsterno(data.data.url);
                }
                if (data.data.urlInterno != '' && data.data.urlInterno != undefined) {
                  this.routingService.navigateByUrl('/' + data.data.urlInterno);
                }
              }

            }
          ]
        });
        await alert.present();
      }
    );

    // se ho data.url, va ad un sito esterno, va inserito con https
    // se ho data.urlInterno va ad un link interno, 

    PushNotifications.addListener(
      'pushNotificationActionPerformed',
      async (notification: ActionPerformed) => {
        const data = notification.notification.data;
        // console.log('Action performed: ' + JSON.stringify(notification.notification));
       // console.log(data);
        if (data.url) {
          if (data.url != '' && data.url != undefined) {
            await this.apriUrlEsterno(data.url);
          }

        }
        if (data.urlInterno) {
          if (data.urlInterno != '' && data.urlInterno != undefined) {
            this.routingService.navigateByUrl('/' + data.urlInterno);
          }
        }
        /*  if (data.detailsId) {
           this.router.navigateByUrl(`/home/${data.detailsId}`);
         } */
      }
    );
  }

  // Il payload push non deve poter aprire schemi arbitrari (tel:, intent:, app di terzi):
  // si apre solo https, come gia' previsto dalla convenzione su data.url.
  private async apriUrlEsterno(url: string) {
    const httpsUrl = toHttpsUrl(url);
    if (httpsUrl !== null) {
      await Browser.open({ url: httpsUrl });
    }
  }

  resetBadgeCount() {
    Device.getInfo().then(res => {
      if (res.platform !== 'web') {
        PushNotifications.removeAllDeliveredNotifications();
      }
    });
  }
}